import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectFurnitureFilter } from 'shared/selectors/advancedFilters';

export const FurnitureContainer: FC = () => {
  const { label, value, options } = useSelector(selectFurnitureFilter);

  const onChange = useFilterChangeCallback();

  const handleFurnitureChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setFurniture', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleFurnitureChange} />
    </AdvancedFilterRow>
  );
};
